{
  "mobile_header": {
    "open_sidebar": "Open sidebar",
    "logo_alt": "SparkLayer"
  },
  "sidebar": {
    "close": "Close sidebar",
    "test_mode": "Test mode",
    "nav": {
      "partner_dashboard": "Partner Dashboard",
      "home": "Home",
      "activity": "Activity",
      "pricing": "Pricing",
      "price_lists": "Price lists",
      "price_editor": "Price editor",
      "discounts": "Discounts",
      "customer_groups": "Customer groups",
      "customers": "Customers",
      "companies": "Companies",
      "agents": "Agents",
      "groups": "Groups",
      "roles": "Roles",
      "sales_agents": "Sales agents",
      "forms": "Forms",
      "data_tables": "Data tables",
      "integrations": "Integrations",
      "platform": "Platform",
      "partners": "Partners",
      "customer_sync": "Customer sync",
      "product_sync": "Product sync",
      "storefront": "Storefront",
      "widgets": "Widgets",
      "options": "Options",
      "settings": "Settings",
      "onboarding": "Onboarding",
      "configurations": "Configurations",
      "shipping": "Shipping",
      "api": "API",
      "templates": "Templates"
    },
    "account_nav": {
      "account": "Account",
      "password": "Password",
      "plan": "Plan",
      "team": "Team",
      "sign_out": "Sign out"
    },
    "staff_nav": {
      "staff": "Staff",
      "manage_billing": "Manage Billing",
      "manage_team": "Manage Team",
      "customer_sync": "Customer Sync"
    },
    "actions": {
      "help": "Help",
      "explore_features": "Explore features",
      "return_to_shopify": "Return to Shopify",
      "return_to_wix": "Return to Wix",
      "go_to_storefront": "Go to Storefront"
    },
    "plan_link": {
      "confirm_plan": "Please confirm your plan",
      "select_plan": "Please select a plan",
      "trial_days_left": "{days, plural, =1 {1 day} other {{days} days}} left of trial"
    }
  },
  "user_menu": {
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  },
  "site_switcher": {
    "search_label": "Quick search",
    "search_placeholder": "Search teams",
    "no_teams_found": "Sorry, no teams found.",
    "create_team": "Create Team",
    "advanced_search_prompt": "Can't find what you're looking for?",
    "use_regular_search": "Return to regular search",
    "use_advanced_search": "Try our advanced search"
  }
}
